/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespIconBubbles_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_user">;
    readonly " $refType": "PdpRespIconBubbles_user";
};
export type PdpRespIconBubbles_user$data = PdpRespIconBubbles_user;
export type PdpRespIconBubbles_user$key = {
    readonly " $data"?: PdpRespIconBubbles_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b7a8dd895310a3ea7fad8ff60cbc97c3';
export default node;
